import {Helmet} from '@dr.pogodin/react-helmet';
import {Box, Grid, GridItem, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';
import {testIds, vehiclesRoutes} from '@dms/routes';
import {DmsDataGrid, FullScreenModal} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const EXTERNAL_FILTER_ID = 'warehouseMovementsFilter';
const PREDEFINED_COLUMNS = ['vehiclePublicId'] as const;

export function WarehouseMovements() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    getColumnData,
  }) => {
    if (actionKey !== 'vehicleDetail') {
      return;
    }

    const vehicleId = getColumnData<{id: string}>('vehiclePublicId')?.value?.id;

    navigate(
      composePath(vehiclesRoutes.vehicleWarehouseInfo, {
        params: {
          id: vehicleId,
        },
      })
    );
  };

  const close = () => {
    navigate(vehiclesRoutes.vehicleWarehouses);
  };

  return (
    <>
      <Helmet title={i18n.t('page.vehicles.warehouseMovements')} />
      <FullScreenModal
        headline={i18n.t('page.vehicles.warehouseMovements')}
        actions={[
          {
            variant: 'secondary',
            title: i18n.t('general.actions.close'),
            onClick: close,
            'data-testid': testIds.vehicles.create('header-close-action'),
          },
        ]}
      >
        <Box padding={4} height="100%">
          <VStack spacing={4} height="100%">
            <Grid columns={3}>
              <GridItem span={2}>
                <div id={EXTERNAL_FILTER_ID} />
              </GridItem>
            </Grid>
            <Box flex={1}>
              <DmsDataGrid
                gridCode="vehicle-warehouse-movement"
                externalFilterId={EXTERNAL_FILTER_ID}
                actionCallback={actionCallback}
                predefinedColumns={PREDEFINED_COLUMNS}
              />
            </Box>
          </VStack>
        </Box>
      </FullScreenModal>
    </>
  );
}
